import { render, staticRenderFns } from "./AddReport.vue?vue&type=template&id=522fc010"
import script from "./AddReport.vue?vue&type=script&lang=js"
export * from "./AddReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports